import styled from "styled-components";

const Title = styled.div`
  color: #5e514d;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  margin: 4px 0 8px 0;
  font-weight: bold;
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 12px;

  &.title-lg {
    font-size: 24px;
    line-height: 36px;
  }
`;

const Subtitle = styled.div` 
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  margin-bottom: 0;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  color: #8a8d8f;

  &.title-lg {
    font-weight: normal;
    -webkit-line-clamp: 2;
  }
`;

const Container = styled.div`
  padding: 6px 0 8px 0;
  border-bottom: 1px solid #edeeee;

  &:last-child {
    padding: 6px 0 0 0;
    border-bottom: none;
  }

  &:hover {
    border-bottom: 1px solid #f2a900;
  }

  &:hover ${Title} {
    color: #f2a900;
    cursor: pointer;
  }
`;

const Article = (props) => {
  const toLink = () => {
    if (props.type === "announcement") {
      window.location.href = `/article-detail/${props.slug}`;
    } else if (props.type === "pressconference") {
      window.location.href = `/article-detail2/${props.slug}`;
    } else if (props.type === "newsroom") {
      window.location.href = `/article-detail3/${props.slug}`;
    } else if(props.type === "inspirasi"){
      window.location.href = `/inspiration/artikel/${props.slug}`;
    }
  };

  return (
    <Container onClick={() => toLink()}>
      <Title className={props.largeTitle ? "title-lg" : ""}>
        {props.title}
      </Title>
      <Subtitle className={props.largeTitle ? "title-lg" : ""}>
        {props.subtitle}
      </Subtitle>
    </Container>
  );
};

export default Article;
